import React from "react";

const Hero = () => {
  return (
    // Main Section Container: White background, padding for spacing
    <section className="bg-white pt-20 pb-16 lg:pt-32 lg:pb-24 overflow-hidden">
      {/* Container: Centers content and manages max-width */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Flexbox Layout: 
             - 'lg:flex-row': On desktop, row layout (Text Left, Image Right)
             - 'flex-col-reverse': On mobile, column layout (Image Top, Text Bottom)
        */}
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-16">
          {/* Text Content Area (Left side on desktop) */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            {/* Badge/Tag: Small text above the title */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold mb-6 tracking-wide">
              Advanced Software Solutions
            </span>

            {/* Main Headline: Big, bold, dark slate color */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight mb-6">
              Digital Transformation for <br />
              <span className="text-blue-600">Agencies & Governments</span>
            </h1>

            {/* Description: Readable slate-600 color, limits max-width for readability */}
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              We empower organizations and government agencies with custom
              website designs and secure, stable database systems to modernize
              their infrastructure and maximize efficiency.
            </p>

            {/* Action Buttons Container */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              {/* Primary CTA Button: Blue background, hover effect, shadow */}
              {/* <button className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-1">
                Start Your Project
              </button> */}

              {/* Secondary Button: Light gray background, outline style */}
              {/* <button className="px-8 py-4 bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold rounded-lg transition-all duration-300 border border-slate-200">
                View Portfolio
              </button> */}
            </div>

            {/* Trust Indicators / Features List */}
            <div className="mt-12 pt-8 border-t border-slate-200 flex flex-wrap justify-center lg:justify-start gap-8 text-slate-500">
              <div className="flex items-center gap-2">
                {/* Check Icon */}
                <svg
                  className="w-5 h-5 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span className="text-sm font-medium">
                  Guaranteed Data Security
                </span>
              </div>
              <div className="flex items-center gap-2">
                {/* Lightning Icon */}
                <svg
                  className="w-5 h-5 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  ></path>
                </svg>
                <span className="text-sm font-medium">
                  High Speed & Stability
                </span>
              </div>
            </div>
          </div>

          {/* Image Content Area (Right side on desktop) */}
          <div className="w-full lg:w-1/2 relative">
            {/* Decorative Background Blobs: Create depth and color behind the image */}
            <div className="absolute -top-10 -right-10 w-72 h-72 bg-blue-50 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
            <div className="absolute -bottom-10 -left-10 w-72 h-72 bg-slate-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>

            {/* Main Image Wrapper: Adds border and shadow */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-100">
              <img
                src="https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Dashboard and Database Analytics"
                className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>

            {/* Floating Card: Adds a professional "stat" on top of the image */}
            <div className="absolute bottom-6 right-6 bg-white/90 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-slate-200 hidden sm:block">
              <div className="flex items-center gap-3">
                <div className="bg-green-100 p-2 rounded-full text-green-600">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-slate-500">Successful Projects</p>
                  <p className="text-sm font-bold text-slate-900">
                    +50 Gov. Agencies
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
